import React from 'react';
import PaymentsCard from '../PaymentsCard/PaymentsCard';

export default function BonusesEarned({ bonusesEarned }) {
  return (
    <PaymentsCard
      title="Bonuses Earned to Date"
      icon="coin"
      description="Total Earned Bonuses"
      total={bonusesEarned.onDayBonusTotal}
      img="payments_bg_layer2"
    >
      <div className="row no-gutters">
        <div className="col-6">
          <p className="text-left ml-2">On the day</p>
        </div>
        <div className="col-6">
          <h5 className="text-right">{bonusesEarned.onDayBonusCount}</h5>
        </div>
      </div>
    </PaymentsCard>
  );
}
